class DocumentTitleManager {
    constructor() {
        this._title = '';
        this._companyName = '';
        this.applyTitle();
    }

    setTitle(title) {
        this._title = title;
        this.applyTitle();
    }

    applyTitle() {
        document.title = this.computeTitle();
    }

    setCompanyName(companyName) {
        this._companyName = companyName;
        this.applyTitle();
    }

    computeTitle() {
        if (this._title && this._companyName) {
            return `${this._title} | ${this._companyName}`;
        } else if (this._title && !this._companyName) {
            return `${this._title}`;
        } else if (!this._title && this._companyName) {
            return `${this._companyName}`;
        }
        return '-';
    }
}

const service = new DocumentTitleManager();
export default service;
